import assertNever from 'assert-never';

import { AddDevicesToGatewayResult, AddDeviceToGatewayStatus } from '@shure/cloud/shared/models/devices';

import { AddDevicesToGatewayOpResult, CloudGatewayAddDeviceStatus } from '../graphql/generated/cloud-sys-api';

export function mapAddDevicesToGatewayResultFromSysApi(result: AddDevicesToGatewayOpResult): AddDevicesToGatewayResult {
	return {
		devices: result.addDevicesToCloudGateway.map((deviceResult) => ({
			hardwareId: deviceResult.hardwareId,
			status: mapCloudGatewayAddDeviceStatusFromSysApi(deviceResult.status)
		}))
	};
}

function mapCloudGatewayAddDeviceStatusFromSysApi(status: CloudGatewayAddDeviceStatus): AddDeviceToGatewayStatus {
	switch (status) {
		case CloudGatewayAddDeviceStatus.CloudGatewayCannotProxy:
			return AddDeviceToGatewayStatus.GatewayCannotProxy;
		case CloudGatewayAddDeviceStatus.CloudGatewayMaxDevicesLimitReached:
			return AddDeviceToGatewayStatus.MaxDeviceLimitReached;
		case CloudGatewayAddDeviceStatus.CloudGatewayNotEnabled:
			return AddDeviceToGatewayStatus.GatewayNotEnabled;
		case CloudGatewayAddDeviceStatus.CloudGatewayNotFound:
			return AddDeviceToGatewayStatus.GatewayNotFound;
		case CloudGatewayAddDeviceStatus.DeviceNotFound:
			return AddDeviceToGatewayStatus.DeviceNotFound;
		case CloudGatewayAddDeviceStatus.Failure:
			return AddDeviceToGatewayStatus.GenericFailure;
		case CloudGatewayAddDeviceStatus.Success:
			return AddDeviceToGatewayStatus.Success;
		case CloudGatewayAddDeviceStatus.UnsupportedDeviceFirmwareVersion:
			return AddDeviceToGatewayStatus.UnsupportedFirmwareVersion;
		default:
			assertNever(status);
	}
}
